export default "__VITE_ASSET__Cdqd14FQ__"